export default __webpack_public_path__ + "locales/hy-AM/Common.json?hash=bbf82d36639b735f188ab336ee071466";